import { useDecoratedStorage } from '../../../services/Firestore/Resources';

export const AddressTitle = ({ id }) => {
  const [addressTitleStorage, addressTitleStorageLoading] = useDecoratedStorage(id);
  if (addressTitleStorageLoading) return 'Loading...';
  let name = '';
  if (addressTitleStorage && addressTitleStorage.lineageNames) {
    addressTitleStorage.lineageNames.forEach((lineageName, index) => {
      if (index > 0) name += ' ';
      name += lineageName;
    });
    return name;
  }
  return 'N/A';
};
